<template>
  <base-modal v-model="localValue" @hidden="resetForm" @shown="loadForm">
    <h3 v-html="$t('healthMonitoring')" class="text-center mb-4"></h3>
    <b-row class="justify-content-center">
        <b-col cols="12" md="4">
            <h5 v-text="$t('reminderFrequency')"></h5>
        </b-col>
        <b-col cols="12">
            <b-row class="justify-content-center">
                <b-col cols="12" md="2">
                    <base-input v-model="data.interval" type="number" :min="1" :max="24" :placeholder="$t('frequency')"></base-input>
                </b-col>
                <b-col cols="12" md="3">
                    <base-select v-model="data.intervalPeriod" :loading="false" :options="reminderIntervalSource" label="name" valueProp="value" :placeholder="$t('reminderMedicationForm.option')"></base-select>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
    <b-row class="justify-content-center">
        <b-col cols="12">
            <h5 class="mt-3" v-text="$t('reminderMedicationForm.endDate')"></h5>
        </b-col>
        <b-col cols="12" md="3">
            <base-datepicker v-model="data.endDate" dateAfterNow></base-datepicker>
        </b-col>
    </b-row>
    <div v-if="created" class="text-center mb-4">
        <base-button red @click="removeReminder">{{ $t('removeReminder') }}</base-button>
    </div>
    <div class="text-center">
        <base-button @click="save">{{ $t('save') }}</base-button> <base-button gray @click="resetForm">{{ $t('cancel') }}</base-button>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from '../base/BaseModal.vue'
import BaseDatepicker from '../base/forms/BaseDatepicker.vue'
import ClinicHistoryRepository from '@/repositories/ClinicHistoryRepository'

const messages = {
    es: {
     'healthMonitoring': 'Seguimiento de salud',
     'reminderFrequency': 'Frecuencia del recordatorio',
     'frequency': 'Frecuencia',
     'removeReminder': 'Eliminar recordatorio',
    'reminderMedicationForm': {
        'alias': 'Alias para el medicamento',
        'aliasInput': 'Introduzca un nombre corto para identificar el medicamento en la agenda',
        'startDate': 'Fecha de inicio',
        'endDate': 'Fecha fin',
        'color': 'Color para hueco de agenda',
        'interval': 'Intervalo del recordatorio',
        'selectInterval': 'Seleccione un intervalo',
        'hour': 'Seleccione una hora',
        'reminderEach': 'Recordar cada...',
        'repeatEach': 'Repetir cada',
        'error': {
            'alias': 'Debe introducir un alias para el medicamento',
            'endDate': 'Debe introducir la fecha de fin para el recordatorio',
            'dateBefore': 'La fecha de inicio debe ser mayor a la actual',
            'color': 'Debe seleccionar un color para el hueco de la agenda',
            'interval': 'Debe seleccionar el intervalo de repetición del recordatorio',
            'startGreater': 'La fecha de fin debe ser mayor que la de inicio',
            'startGreaterThanNow': 'La fecha de fin del recordatorio debe ser mayor que la fecha actual'
        },
        'option': 'Seleccione una opción',
        'sucess': 'Recordatorio creado correctamente'
    }
  },
  en: {
    'healthMonitoring': 'Health monitoring',
     'reminderFrequency': 'Reminder frequency',
     'frequency': 'Frequency',
     'removeReminder': 'Remove reminder',
    'reminderMedicationForm': {
        'alias': 'Alias ​​for the medication',
        'aliasInput': 'Enter a short name to identify the medication in the phonebook',
        'startDate': 'Start date',
        'endDate': 'End date',
        'color': 'Color for agenda slot',
        'interval': 'Reminder interval',
        'selectInterval': 'Select an interval',
        'hour': 'Select a time',
        'reminderEach': 'Remember every...',
        'repeatEach': 'Repeat Each',
        'error': {
            'alias': 'You must enter an alias for the medication',
            'endDate': 'You must enter the end date for the reminder',
            'dateBefore': 'The start date must be greater than the current date',
            'color': 'You must select a color for the agenda slot',
            'interval': 'You must select the reminder repetition interval',
            'startGreater': 'The end date must be greater than the start date',
            'startGreaterThanNow': 'The reminder end date must be greater than the current date'
        },
        'option': 'Select an option',
        'success': 'Reminder created successfully'
    }
  },
  pt: {
    'healthMonitoring': 'Monitoramento de saúde',
     'reminderFrequency': 'Frequência do lembrete',
     'frequency': 'Frequência',
     'removeReminder': 'Remover lembrete',
    'reminderMedicationForm': {
        'alias': 'Alias ​​do medicamento',
        'aliasInput': 'Digite um nome abreviado para identificar o medicamento na agenda',
        'startDate': 'Data de início',
        'endDate': 'Data de término',
        'color': 'Cor para slot de agenda',
        'interval': 'Intervalo de lembrete',
        'selectInterval': 'Selecione um intervalo',
        'hour': 'Selecione um horário',
        'reminderEach': 'Lembrar de cada...',
        'repeatEach': 'Repetir Cada',
        'error': {
            'alias': 'Você deve inserir um alias para o medicamento',
            'endDate': 'Você deve inserir a data de término do lembrete',
            'dateBefore': 'A data de início deve ser posterior à data atual',
            'color': 'Você deve selecionar uma cor para o espaço da agenda',
            'interval': 'Você deve selecionar o intervalo de repetição do lembrete',
            'startGreater': 'A data de término deve ser posterior à data de início',
            'startGreaterThanNow': 'A data de término do lembrete deve ser posterior à data atual'
        },
        'option': 'Selecione uma opção',
        'success': 'Lembrete criado com sucesso'
    }
  }
}

export default {
    components: {
        BaseModal,
        BaseDatepicker
    },
    data () {
        return {
            localValue: false,
            data: {
                varName: null,
                endDate: null,
                interval: null,
                intervalPeriod: null
            }
        }
    },
    props: {
        value: Boolean,
        varName: String,
        created: Boolean
    },
    i18n: {messages},
    methods: {
        loadForm () {
            if (this.created) {
                ClinicHistoryRepository(this.$route.query).getVariableTracking(this.varName).then(response => {
                    let data = response.data.data
                    if (data) {
                        this.data.endDate = data.endDate
                        this.data.interval = data.interval
                        this.data.intervalPeriod = data.intervalPeriod
                    }
                })
            }
        },
        save () {
            if (this.data.interval === null) {
                this.$store.dispatch('showInfoAlert', this.$t('reminderMedicationForm.error.interval'))
            } else if (this.data.intervalPeriod === null) {
                this.$store.dispatch('showInfoAlert', this.$t('reminderMedicationForm.error.interval'))
            } else if (!this.data.endDate) {
                this.$store.dispatch('showInfoAlert', this.$t('reminderMedicationForm.error.endDate'))
            } else if (new Date() >= new Date(this.data.endDate)) {
                this.$store.dispatch('showInfoAlert', this.$t('reminderMedicationForm.error.startGreaterThanNow'))
            } else {
                ClinicHistoryRepository(this.$route.query).saveVariableTracking(this.buildReminderData()).then(response => {
                    if (response.data.data) {
                        this.$store.dispatch('showSuccessAlert', this.$t('reminderMedicationForm.sucess'))
                        this.resetForm()
                        this.$emit('reminderCreated', true)
                    } else {
                        this.$store.dispatch('showDangerAlert', this.$t('error.try-again'))
                    }
                })
            }
        },
        removeReminder () {
            ClinicHistoryRepository(this.$route.query).removeVariableTracking(this.varName).then(response => {
                    if (response.data.data) {
                        this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
                        this.resetForm()
                        this.$emit('reminderCreated', false)
                    } else {
                        this.$store.dispatch('showDangerAlert', this.$t('error.try-again'))
                    }
                })
        },
        buildReminderData () {
            return {
                endDate: this.data.endDate,
                interval: this.data.interval,
                varName: this.varName,
                intervalPeriod: this.data.intervalPeriod
            }
        },
        resetForm () {
            this.data.endDate = null
            this.data.interval = null
            this.data.intervalPeriod = null
            this.localValue = false
        }
    },
    computed: {
        reminderIntervalSource () {
            return [{ name: this.$t('hours'), value: 0 }, { name: this.$t('days'), value: 1 }, { name: this.$t('weeks'), value: 7 }, { name: this.$t('months'), value: 30 }]
        }
    },
    watch: {
        value (val) {
            this.localValue = val
        },
        localValue (val) {
            this.$emit('input', val)
        }
    }
}
</script>

<style lang="scss" scoped>
.row h5{
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/HistoryVariableReminder.vue